// eslint-disable-next-line import/no-extraneous-dependencies
import { FuroDataTextareaInput } from '@furo/data-input/src/furo-data-textarea-input.js';

export class FormFatFatmultilinetext extends FuroDataTextareaInput {}

window.customElements.define('form-fat-fatmultilinetext', FormFatFatmultilinetext);
